import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { EnrolmentDevice } from "../../models/EnrolmentDevices";
import { Name } from "../../models/Name";
import { getMasterCredentialsWithPagination } from "../../services/credentialsService";
import { appendFilter } from "../../utilities/filters";
import List from "../list/list";

interface Props {
    onNext: (event: any) => void;
    masterId: number | undefined;
    onBack: (event: any) => void;
}

interface Data {
    value: string,
    code: string
}

const ChooseCard: FC<Props> = ({ onNext, masterId, onBack }) => {
    const [value, setValue] = useState<string>('');
    const [code, setCode] = useState('');
    const [isTaskSelected, setIsTaskSelected] = useState(false);
    const { translate } = useLocale();
    const [items, setItems] = useState<{ value: JSX.Element; isSelected: boolean; }[]>([]);
    const { values } = useFormikContext<any>();
    const enrolmentDevice = new EnrolmentDevice(translate);

    useEffect(() => {
        getListItems();
    }, [masterId])

    const itemSelected = (item: any) => {
        const selectedItem = item.props['data-item'];
        if (selectedItem) {
            setIsTaskSelected(true);
            setValue(selectedItem.value);
            setCode(selectedItem.label);
        }

        onLocalNext({}, {value: selectedItem.value, code: selectedItem.label});
    }

    const getListItems = async () => {
        try {
            const cards = (await getMasterCredentialsWithPagination({ filters: appendFilter(masterId, 'Master', 'master.id', []) })).rows;

            if (cards.length === 0) {
                setItems(getNoCardItems());
                return;
            }

            cards.push({ label: translate.byKey(TranslationKeys.newRandomPAC), value: enrolmentDevice.RANDOM_PAC.value, optionalColumns: [{ key: "tagType", value: "" }] });
            setItems(getCardsItems(cards));
        } catch (error) {
            setItems(getNoCardItems());
        }
    }

    const getCardsItems = (cards: Name[]): { value: JSX.Element; isSelected: boolean; }[] => {
        return cards.map(item => {
            return {
                value: (
                    <div className="grid grid-cols-2 gap-3 cursor-pointer select-none" data-item={item}>
                        <div>{item.label}</div>
                        <div className="flex justify-start">{item.optionalColumns[0].value}</div>
                    </div>
                ),
                isSelected: item.value === value
            };
        })
    }

    const getNoCardItems = (): { value: JSX.Element; isSelected: boolean; }[] => {
        return [enrolmentDevice.MANUAL_CODE_TYPE, enrolmentDevice.RANDOM_PAC].map(item => {
            return {
                value: (
                    <div className="flex flex-row items-center cursor-pointer select-none" data-item={item}>
                        <div id={`task-` + item.id} className="p-2">{item.label}</div>
                    </div>
                ),
                isSelected: item.value === value
            };
        })
    }

    const onLocalNext = (event: any, data?: Data) => {
        if (data) {
            onNext({ ...data, values });
        } else if (isTaskSelected) {
            onNext({ ...event, code, value, values });
        }
    }

    return <div className="overflow-y-auto" style={{ height: '90%' }}>
        <List onSelect={(_, item) => itemSelected(item)} isStriped items={items} />
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-8 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary ${isTaskSelected ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    onClick={e => onLocalNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}

export default ChooseCard;
